import ApiRouteProvider from '../route'
import axios from '@axios'
import Cache from "@core/api/request/Cache";

function buildFormData(formData, data, parentKey)
{
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? '' : data;

        formData.append(parentKey, value);
    }
}

function prepareNews(news)
{
    const formData = new FormData();
    const data = {
        ...news,
        categories: news.categories.map(c => c.id)
    };
    ['id', 'title', 'content', 'image'].forEach(f => {
        if (data[f] !== undefined) {
            delete data[f];
        }
    });

    buildFormData(formData, data);
    return formData;
}

export default {
    getParsedSystemContent(key) {
        // return Cache.item('pages.parsed_system_content.' + key, () => {
            return axios.get(ApiRouteProvider.pages.getParsedSystemContent(key));
        // }).getPromise();
    },
    systemContent(page, perPage) {
        return axios.get(ApiRouteProvider.pages.systemContent({
            page,
            perPage
        }));
    },
    getSystemContent(id) {
        return axios.get(ApiRouteProvider.pages.getSystemContent(id));
    },
    updateSystemContent(id, content) {
        return axios.put(ApiRouteProvider.pages.updateSystemContent(id), content);
    },


    deleteNews(id) {
        return axios.delete(ApiRouteProvider.pages.deleteNews(id));
    },
    getFeaturedNews() {
        return Cache.item('pages.featured_news', () => {
            return axios.get(ApiRouteProvider.pages.featuredNews());
        }).getPromise();
    },
    news(page, perPage) {
        // return Cache.item('pages.categories', () => {
        return axios.get(ApiRouteProvider.pages.news({
            page,
            perPage
        }));
        // }).getPromise();
    },
    getNews(id) {
        return axios.get(ApiRouteProvider.pages.getNews(id));
    },
    createNews(news) {
        return axios.post(ApiRouteProvider.pages.createNews(), prepareNews(news));
    },
    updateNews(id, news) {
        return axios.post(ApiRouteProvider.pages.updateNews(id), prepareNews(news));
    },

    categories(page, perPage) {
        // return Cache.item('pages.categories', () => {
            return axios.get(ApiRouteProvider.pages.categories({
                page,
                perPage
            }));
        // }).getPromise();
    },
    deleteCategory(id) {
        return axios.delete(ApiRouteProvider.pages.deleteCategory(id));
    },
    getCategory(id) {
        return axios.get(ApiRouteProvider.pages.getCategory(id));
    },
    createCategory(category) {
        return axios.post(ApiRouteProvider.pages.createCategory(), category);
    },
    updateCategory(id, category) {
        return axios.put(ApiRouteProvider.pages.updateCategory(id), category);
    }
};
